import { DependenciesInjection } from "app/di/DependencyInjection";
import { SidebarMenuConfigRepository } from "../data/SidebarMenuConfigRepository";
import { IConfigRepository } from "../domain/repositories/IConfigRepository";
import { SidebarMenuUseCase } from "../domain/useCases/SidebarMenuUseCase";
import { SidebarMenuToken } from "./SidebarMenuToken";

export class SidebarMenuInjection {
  static initInjections() {
    DependenciesInjection.register<IConfigRepository>(
      SidebarMenuToken.IConfigRepository,
      SidebarMenuConfigRepository,
      "otherRepo",
    );
    DependenciesInjection.register<SidebarMenuUseCase>(
      SidebarMenuToken.SidebarMenuUseCase,
      SidebarMenuUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IConfigRepository>(
      SidebarMenuToken.IConfigRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<SidebarMenuUseCase>(
      SidebarMenuToken.SidebarMenuUseCase,
    );
  }
}
